var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUtility(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.88889 7.12035V6.39812H4.33333V7.12035H8.66667V6.39812H10.1111V7.12035H13V6.03701C13 5.03962 12.1918 4.23146 11.1944 4.23146H9.38889V3.14812C9.38889 2.15507 8.57639 1.34257 7.58333 1.34257H5.41667C4.42361 1.34257 3.61111 2.15507 3.61111 3.14812V4.23146H1.80556C0.808167 4.23146 0 5.03962 0 6.03701V7.12035H2.88889ZM5.05556 3.14812C5.05556 2.9524 5.22094 2.78701 5.41667 2.78701H7.58333C7.77906 2.78701 7.94444 2.9524 7.94444 3.14812V4.23146H5.05556V3.14812Z",
    fill: "#4F6E90"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1111 8.81586V8.09364H13V10.6214C13 11.6188 12.1918 12.427 11.1944 12.427H1.80556C0.808167 12.427 0 11.6188 0 10.6214V8.09364H2.88889V8.81586H4.33333V8.09364H8.66667V8.81586H10.1111Z",
    fill: "#8DADD0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtility);
export default __webpack_public_path__ + "static/media/Utility.b384505973fa483c04d1377544198b2a.svg";
export { ForwardRef as ReactComponent };